module.exports = __webpack_public_path__ + "static/media/nv-moka.11077547.jpg";